import React, { BaseSyntheticEvent, FC } from "react";
import laptop from "./laptop.webp";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { isUpgradeShow } from "../../../graphql/state";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";

type Props = {
  show: boolean;
  onCancel?: () => void;
};

export const UpgradePlanModal: FC<Props> = ({ show, onCancel }) => {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();
  const navigate = useNavigate();

  const moveToPaymentPage = () => {
    navigate(`${lng}/payment`);
    isUpgradeShow(false);
  };

  const closeByBackground = (e: BaseSyntheticEvent) => {
    e.stopPropagation();
    if (e.target.id === "confirmModal") onCancel();
  };

  return (
    <div
      id="confirmModal"
      className={`modal ${
        show ? "show d-flex" : ""
      } align-items-center justify-content-center`}
      style={{
        display: show ? "block" : "none",
        background: "rgb(0, 0, 0, 0.6)",
      }}
      onClick={(e) => closeByBackground(e)}
    >
      <div className="col-11" style={{ maxWidth: "500px" }}>
        <div className="modal-content text-break d-flex flex-column align-items-center">
          <div className="col-12 modal-header pb-2 border-0">
            <button
              className="btn-close"
              aria-label="Close"
              onClick={onCancel}
              style={{ height: "16px", width: "16px", opacity: "1" }}
            ></button>
          </div>
          <div className="border-0 text-center d-flex flex-column align-items-center px-5">
            <h5 className="col-9 col-md-8 fw-700 fs-4 text-dark-gray mb-3">
              {t("modal.titleUpgrade")}
            </h5>
            <img className="mb-3" src={laptop} alt="laptop" />
            <p
              className="description-responsive text-light-gray"
              style={{ marginBottom: "28px" }}
            >
              {t("modal.descriptionUpgrade")}
            </p>
          </div>
          <div className="col-12 px-4 pb-4 text-center">
            <button
              type="button"
              className="btn btn-primary text-white fw-bold col-12 py-3 mb-3"
              onClick={moveToPaymentPage}
            >
              {t("modal.upgrade")}
            </button>
            <p
              onClick={onCancel}
              className="d-inline text-decoration-underline m-0 cursor-pointer"
            >
              {t("folder.cancel")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
